import { SatelliteAltTwoTone } from "@mui/icons-material";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    error : null
}

export function generalErrorAction (where, code, status, message, payload) {
    return {
        where,
        code,
        status,
        message,
        payload
    }
}

export const generalErrorSlice = createSlice({
    name: "general-error",
    initialState,
    reducers: {
        publicarError : (state, action ) => {
            state.error = action.payload
        },
        removeError : (state) => {
            state.error = null
        }
    }
})

export const {
    publicarError,
    removeError
} = generalErrorSlice.actions;

export default generalErrorSlice.reducer;